import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { MapService } from '../../services/map.service';
import { RailOccurrenceService } from '../../services/rail/rail-occurrence.service';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { combineLatest, Subscription } from 'rxjs';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    imports: [CommonModule, MaterialModule, MatProgressSpinner],
    providers: [],
    standalone: true
})
export class LoadingComponent implements OnInit, OnDestroy {
  loadingMessage = 'Sincronizando dados...';
  private loadingSub?: Subscription;

  constructor(
    public loadingService: LoadingService,
    private mapService: MapService,
    private occurrenceService: RailOccurrenceService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Monitora as requisições de forma reativa e define a mensagem específica correspondente
    this.loadingSub = combineLatest([
      this.mapService.hasPendingGetData$,
      this.occurrenceService.hasPendingOccurrences$
    ]).subscribe(([pendingLayers, pendingOccurrences]) => {
      if (pendingLayers) {
        this.loadingMessage = 'Carregando camadas espaciais...';
      } else if (pendingOccurrences) {
        this.loadingMessage = 'Carregando ocorrências...';
      } else {
        this.loadingMessage = 'Sincronizando dados...';
      }
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.loadingSub?.unsubscribe();
  }
}
